// 继续率系数
export default {
  data() {
    return {
      payPeriodFull: '',
      list: [],
      indexList: []
    };
  },
  methods: {
    initData(init) {
      this.topItem.commissionItems
      const close = this.$notice.loading();
      this.$http({
        url: '/buz/upcommission/queryConfigRetentionRate',
        type: 'GET',
        data: {
          productCode: this.topItem.productCode,
        }
      })
        .then(res => {
          if (res.data && res.data.rateItemList) {
            res.data.rateItemList.forEach((item, i) => {
              item.key = 'a' + i;
              item.coefficientItemList.forEach((item2, ii) => {
                item2.key = 'b' + ii;
                // 根据产品原始费用方案组装数据
                const list = JSON.parse(JSON.stringify(this.topItem.commissionItems));
                list.forEach((item3, iii)=>{
                  item3.key = 'c' + iii;
                  item3.programBaseList.forEach((item4, iiii)=>{
                    item4.key = 'd' + iiii;
                    item4.programId = item4.id;
                    item4.gradeCode = item3.gradeCode;
                    item4.coefficient = 0;
                    item2.coefficientValueItemList.forEach((item5) => {
                      if(item4.programId == item5.programId && item4.gradeCode == item5.gradeCode) {
                        item4.coefficient = item5.coefficient;
                      }
                    });
                  })
                  item3.coefficientValueItemList = item3.programBaseList;
                  delete item3.programBaseList;
                })
                item2.coefficientValueGradeList = list;
              });
            });
            this.list = res.data.rateItemList;
            console.log(this.list);
          } else if (init) {
            this.list = [];
            this.addRow();
          } else {
            this.list = [];
          }
          if(this.over) {
            this.visible = true;
          }
        })
        .finally(() => {
          close();
        });
    }
  }
};
